import { render } from "./DepartmentChargeModal.vue?vue&type=template&id=0773b0f2"
import script from "./DepartmentChargeModal.vue?vue&type=script&lang=js"
export * from "./DepartmentChargeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/WebOrders/DepartmentChargeModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0773b0f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0773b0f2', __exports__)) {
    api.reload('0773b0f2', __exports__)
  }
  
  module.hot.accept("./DepartmentChargeModal.vue?vue&type=template&id=0773b0f2", () => {
    api.rerender('0773b0f2', render)
  })

}


export default __exports__